<template>
	<sBox title="Grid de formulários">
		<div slot="tools">
			<aBtn
				action="private-save-forms"
				@click="$router.push('/create-forms')"
				text="Formulário"
				icon="plus"
				size="sm"
				type="success"
			/>
		</div>
		<div slot="body">
			<sTable
				ref="tab"
				actionRead="private-read-forms"
				actionDelete="private-delete-forms"
				:labels="labels"
				:actions="['delete', 'edit']"
				:functions="functions"
				@edit="(data) => $router.push(`/edit-form/${data.cod}`)"
			/>
		</div>
	</sBox>
</template>
<script>
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import pad from 'js/pad';
	import eDate from 'js/date';

	export default {
		components: { sTable, sBox, aBtn },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'titulo', label: 'Formulário' },
					{
						data: ['cod_user.nome', 'cod_user.sobrenome'],
						label: 'Usuário',
					},
					{ data: 'evento', label: 'Data' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
					{
						cod: 'evento',
						fx: (val) => {
							return eDate(val, 'DD/MM/YY ás HH:II');
						},
					},
				],
			};
		},
		mounted() {
			this.$emit('setHeader', ['Modelos de Formulários', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/forms/index.vue